module.exports = __webpack_public_path__ + "media/img/frontend_application/venue/books-icon-6f1fdfc8a71d74f3f03d3b8e21dc1bbd.png";